import { Stack } from '@atlaskit/primitives';
import { IconCardGroup } from '@af/design-system-docs-ui';
import { VideoPlayer } from "../../../../src/components/video-player";
import { GuidanceCard } from "../../../../src/components/guidance-cards/guidance-cards";
import { guidanceCardComponents, guidanceCardContent, guidanceCardDesigningMessages, guidanceCardFigmaLibrariesPage, guidanceCardAssetLibrary, guidanceCardWritingToolkit, guidanceCardSAC, guidanceCardTrainingFigma, guidanceCardTrainingADS, guidanceCardTrainingA11y } from "../../../../src/components/guidance-cards/guidance-card-content";
import { contactUsCards } from "../../../../src/pages/contact-us";
import { QuoteCard, quoteCard1, quoteCard2, quoteCard3 } from "../../../../src/components/quote-cards/quote-cards";
import * as React from 'react';
export default {
  Stack,
  IconCardGroup,
  VideoPlayer,
  GuidanceCard,
  guidanceCardComponents,
  guidanceCardContent,
  guidanceCardDesigningMessages,
  guidanceCardFigmaLibrariesPage,
  guidanceCardAssetLibrary,
  guidanceCardWritingToolkit,
  guidanceCardSAC,
  guidanceCardTrainingFigma,
  guidanceCardTrainingADS,
  guidanceCardTrainingA11y,
  contactUsCards,
  QuoteCard,
  quoteCard1,
  quoteCard2,
  quoteCard3,
  React
};